// This is just an example,
// so you can safely delete all default props below

export default {
    forget_password: 'Glemt passord',
    email: 'E-post',
    send: 'Send',
    succeeded: 'E-post sendt',
    failed: 'Feilet',
    desc: 'Skriv inn din registrerte e-postadresse. Du får tilsendt en e-post til registrert adresse slik at du skal få satt nytt passord.'
}
